import { IconName } from '../enums/icon-enum';
import { FooterSection, SocialLink } from '../interfaces/footer.interface';

export const FOOTER_DESCRIPTION = {
  descriptionKey: 'footer.description',
  description:
    'With the highest-converting checkout and flexible options for every size of business, we help to sell more products, lower your costs, and save your time.',
};

export const FOOTER_SECTIONS: FooterSection[] = [
  {
    titleKey: 'footer.aboutUs.title',
    title: 'About us',
    links: [
      {
        labelKey: 'footer.aboutUs.subscriptions',
        label: 'Subscriptions',
        url: '/subscriptions',
      },
    ],
  },
  {
    titleKey: 'footer.legal.title',
    title: 'Legal',
    links: [
      {
        labelKey: 'footer.legal.termsConditions',
        label: 'Terms & Conditions',
        url: '/terms-conditions',
      },
      {
        labelKey: 'footer.legal.privacyPolicy',
        label: 'Privacy Policy',
        url: '/privacy-policy',
      },
      {
        labelKey: 'footer.legal.cookiesPolicy',
        label: 'Cookies Policy',
        url: '/cookies-policy',
      },
    ],
  },
  {
    titleKey: 'footer.contact.title',
    title: 'Contact us',
    links: [
      {
        labelKey: 'footer.contact.sales',
        label: 'sales@retailtech.com',
        url: 'mailto:sales@retailtech.com',
      },
      {
        labelKey: 'footer.contact.support',
        label: 'support@retailtech.com',
        url: 'mailto:support@retailtech.com',
      },
      {
        labelKey: 'footer.contact.phone',
        label: '+1 123 456 7789',
        url: 'tel:+11234567789',
      },
    ],
  },
];

export const SOCIAL_LINKS: SocialLink[] = [
  {
    icon: IconName.YOUTUBE,
    url: 'https://youtube.com/retailtech',
    ariaLabel: 'YouTube',
  },
  {
    icon: IconName.TWITTER,
    url: 'https://twitter.com/retailtech',
    ariaLabel: 'Twitter',
  },
  {
    icon: IconName.INSTAGRAM,
    url: 'https://instagram.com/retailtech',
    ariaLabel: 'Instagram',
  },
  {
    icon: IconName.FACEBOOK_WHITE,
    url: 'https://facebook.com/retailtech',
    ariaLabel: 'Facebook',
  },
  {
    icon: IconName.LINKEDIN,
    url: 'https://linkedin.com/company/retailtech',
    ariaLabel: 'LinkedIn',
  },
];

export const COPYRIGHT = {
  copyrightKey: 'footer.copyright',
  copyright: '© 2024 RetailTech',
};
